import { render, staticRenderFns } from "./ItsWaybillDetailSecond.vue?vue&type=template&id=fb43936c&scoped=true&"
import script from "./ItsWaybillDetailSecond.vue?vue&type=script&lang=js&"
export * from "./ItsWaybillDetailSecond.vue?vue&type=script&lang=js&"
import style0 from "./ItsWaybillDetailSecond.vue?vue&type=style&index=0&id=fb43936c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb43936c",
  null
  
)

export default component.exports